// frontend/src/components/SiteSelector.js
// Phase 8: Role-aware Site Selector
// - UPS users see company-owned sites
// - Agency users see contract-allowed sites
// - selectedSiteId is global and used for site-scoped views

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCompanySites,
  selectAgencyAllowedSites,
  selectSelectedSiteId,
  selectSitesLoading,
  setSelectedSiteId,
} from '../features/sites/sitesSlice';
import { selectUserRole } from '../features/auth/authSlice';

export default function SiteSelector() {
  const dispatch = useDispatch();
  const siteSelectId = 'site-selector';

  const role = useSelector(selectUserRole);
  const selectedSiteId = useSelector(selectSelectedSiteId);
  const loading = useSelector(selectSitesLoading);

  const isAgencyUser = role === 'agency_admin' || role === 'agency_user';
  const sites = useSelector(isAgencyUser ? selectAgencyAllowedSites : selectCompanySites);

  return (
    <div>
      <label htmlFor={siteSelectId} className="block text-sm font-medium text-gray-700 mb-1">Site</label>

      {loading ? (
        <div className="text-sm text-gray-500 py-2">Loading sites…</div>
      ) : !sites.length ? (
        <div className="text-sm text-gray-500 py-2">
          {isAgencyUser ? 'No contract-allowed sites available.' : 'No sites found for this company.'}
        </div>
      ) : (
        <select
          id={siteSelectId}
          name="siteId"
          value={selectedSiteId ?? ''}
          onChange={(e) => dispatch(setSelectedSiteId(e.target.value))}
          className="border rounded h-9 px-2 bg-white w-56"
        >
          {sites.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}{s.code ? ` (${s.code})` : ''}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
